import React from 'react';
import EventsPage from './EventsPage';

const CalendarPage = () => {
  return <EventsPage />;
};

export default CalendarPage;
